// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7c9d2364","498":"54703122","703":"886108c8"}[chunkId] + ".chunk.js";
};